(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kys-all-products-slider"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('kys-product-slider'))customElements.define('kys-product-slider',class extends HTMLElement{
connectedCallback(){
 if(this.controller)return;
 this.controller=new AbortController();
 const signal=this.controller.signal,track=this.querySelector('.kps__track'),buttons=this.querySelectorAll('[data-step]');
 if(!track)return;
 const title=this.querySelector('h2');
 track.id='kps-track-'+title.id.replace('kps-title-','');
 const update=()=>{const max=track.scrollWidth-track.clientWidth;buttons.forEach(b=>b.disabled=Number(b.dataset.step)<0?track.scrollLeft<=1:track.scrollLeft>=max-1)};
 buttons.forEach(b=>b.addEventListener('click',()=>{const card=track.querySelector('.kps__card');if(card)track.scrollBy({left:Number(b.dataset.step)*(card.getBoundingClientRect().width+(parseFloat(getComputedStyle(track).gap)||0)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})},{signal}));
 track.addEventListener('scroll',update,{passive:true,signal});
 this.resizeObserver=new ResizeObserver(update);this.resizeObserver.observe(track);
 let active=false,start=0,left=0,moved=false;
 track.addEventListener('pointerdown',e=>{if(e.pointerType!=='mouse'||e.button!==0)return;active=true;moved=false;start=e.clientX;left=track.scrollLeft},{signal});
 window.addEventListener('pointermove',e=>{if(!active)return;if(Math.abs(e.clientX-start)>5){moved=true;track.classList.add('is-dragging');track.scrollLeft=left-(e.clientX-start)}},{signal});
 const stop=()=>{active=false;track.classList.remove('is-dragging')};
 window.addEventListener('pointerup',stop,{signal});window.addEventListener('pointercancel',stop,{signal});window.addEventListener('blur',stop,{signal});
 track.addEventListener('click',e=>{if(moved){e.preventDefault();e.stopPropagation();moved=false}},{capture:true,signal});
 update();
}
disconnectedCallback(){this.controller?.abort();this.controller=null;this.resizeObserver?.disconnect()}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kys-bundle-cards-en"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kys-bundle-cards')) {
  customElements.define('kys-bundle-cards', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const track = this.querySelector('.kys-bundles__track');
      const previous = this.querySelector('[data-prev]');
      const next = this.querySelector('[data-next]');

      const update = () => {
        previous.disabled = track.scrollLeft < 5;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 5;
      };

      const move = direction => {
        const card = track.querySelector('.kys-bundles__card');

        if (card) {
          track.scrollBy({
            left: direction * (card.getBoundingClientRect().width + 14),
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches
              ? 'instant'
              : 'smooth'
          });
        }
      };

      previous.addEventListener('click', () => move(-1), options);
      next.addEventListener('click', () => move(1), options);
      track.addEventListener('scroll', update, options);

      this.resizeObserver = new ResizeObserver(update);
      this.resizeObserver.observe(track);
      update();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kys-bundle-cards"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('kys-bundle-cards'))customElements.define('kys-bundle-cards',class extends HTMLElement{connectedCallback(){this.controller=new AbortController();const options={signal:this.controller.signal};const track=this.querySelector('.kys-bundles__track');const previous=this.querySelector('[data-prev]');const next=this.querySelector('[data-next]');const update=()=>{previous.disabled=track.scrollLeft<5;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-5};const move=direction=>{const card=track.querySelector('.kys-bundles__card');if(card)track.scrollBy({left:direction*(card.getBoundingClientRect().width+14),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})};previous.addEventListener('click',()=>move(-1),options);next.addEventListener('click',()=>move(1),options);track.addEventListener('scroll',update,options);this.resizeObserver=new ResizeObserver(update);this.resizeObserver.observe(track);update()}disconnectedCallback(){this.controller?.abort();this.resizeObserver?.disconnect()}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kys-product-reviews"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('kys-review-carousel')){customElements.define('kys-review-carousel',class extends HTMLElement{
connectedCallback(){if(this.ready||!this.querySelector('article'))return;this.ready=true;this.track=this.querySelector('[data-review-track]');this.previous=this.querySelector('[data-review-previous]');this.next=this.querySelector('[data-review-next]');this.status=this.querySelector('[data-review-status]');this.cards=[...this.track.children];this.onScroll=()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>this.update());};this.onPrevious=()=>this.move(-1);this.onNext=()=>this.move(1);this.previous.addEventListener('click',this.onPrevious);this.next.addEventListener('click',this.onNext);this.track.addEventListener('scroll',this.onScroll,{passive:true});this.resize=new ResizeObserver(()=>this.update());this.resize.observe(this.track);this.update();}
move(direction){const width=this.cards[0].getBoundingClientRect().width+parseFloat(getComputedStyle(this.track).columnGap);const count=matchMedia('(max-width:749px)').matches?1:3;const limit=this.track.scrollWidth-this.track.clientWidth;const target=Math.max(0,Math.min(limit,this.track.scrollLeft+direction*width*count));this.track.scrollTo({left:target,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});}
update(){const width=this.cards[0].getBoundingClientRect().width+parseFloat(getComputedStyle(this.track).columnGap);const first=Math.round(this.track.scrollLeft/width)+1;const visible=matchMedia('(max-width:749px)').matches?1:3;this.previous.disabled=this.track.scrollLeft<2;this.next.disabled=this.track.scrollLeft>=this.track.scrollWidth-this.track.clientWidth-2;this.status.textContent=first+'–'+Math.min(this.cards.length,first+visible-1)+' / '+this.cards.length;}
disconnectedCallback(){this.resize?.disconnect();this.track?.removeEventListener('scroll',this.onScroll);this.previous?.removeEventListener('click',this.onPrevious);this.next?.removeEventListener('click',this.onNext);cancelAnimationFrame(this.frame);this.ready=false;}
});}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kys-recipe-videos"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kys-recipe-videos')) {
  customElements.define('kys-recipe-videos', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;

      const track = this.querySelector('.kys-recipes__track');
      const position = this.querySelector('.kys-recipes__position');
      const previous = this.querySelector('[data-direction="-1"]');
      const next = this.querySelector('[data-direction="1"]');

      if (!track || !position) return;

      const update = () => {
        const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
        position.disabled = maximum <= 1;

        if (!track.classList.contains('is-dragging')) {
          position.value = maximum > 0
            ? Math.round(track.scrollLeft / maximum * 1000)
            : 0;
        }

        previous.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft >= maximum - 1;
      };

      const step = () => {
        const first = track.firstElementChild;
        return first
          ? first.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).gap) || 0)
          : 0;
      };

      position.addEventListener('input', () => {
        track.classList.add('is-dragging');

        track.scrollTo({
          left: Number(position.value) / 1000 * (track.scrollWidth - track.clientWidth),
          behavior: 'instant'
        });
      });

      position.addEventListener('change', () => {
        track.classList.remove('is-dragging');

        const distance = step();

        if (distance) {
          track.scrollTo({
            left: Math.round(track.scrollLeft / distance) * distance
          });
        }

        update();
      });

      this.querySelectorAll('[data-direction]').forEach(button => {
        button.addEventListener('click', () => {
          track.scrollBy({
            left: Number(button.dataset.direction) * step()
          });
        });
      });

      this.addEventListener('click', event => {
        const button = event.target.closest('[data-play-cover]');
        if (!button || !this.contains(button)) return;

        const template = button.parentElement.querySelector('[data-youtube-player]');
        if (!template) return;

        const player = template.content.firstElementChild.cloneNode(true);
        button.replaceWith(player);
      });

      this.querySelectorAll('video').forEach(video => {
        video.addEventListener('play', () => {
          this.querySelectorAll('video').forEach(other => {
            if (other !== video) other.pause();
          });
        });
      });

      track.addEventListener('scroll', update, { passive: true });

      this.resizeObserver = new ResizeObserver(update);
      this.resizeObserver.observe(track);

      update();
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kys-review-carousel"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('kys-review-carousel')){customElements.define('kys-review-carousel',class extends HTMLElement{
connectedCallback(){if(this.ready||!this.querySelector('article'))return;this.ready=true;this.track=this.querySelector('[data-review-track]');this.previous=this.querySelector('[data-review-previous]');this.next=this.querySelector('[data-review-next]');this.status=this.querySelector('[data-review-status]');this.cards=[...this.track.children];this.onScroll=()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>this.update());};this.onPrevious=()=>this.move(-1);this.onNext=()=>this.move(1);this.previous.addEventListener('click',this.onPrevious);this.next.addEventListener('click',this.onNext);this.track.addEventListener('scroll',this.onScroll,{passive:true});this.resize=new ResizeObserver(()=>this.update());this.resize.observe(this.track);this.update();}
move(direction){const width=this.cards[0].getBoundingClientRect().width+parseFloat(getComputedStyle(this.track).columnGap);const count=matchMedia('(max-width:749px)').matches?1:3;const limit=this.track.scrollWidth-this.track.clientWidth;const target=Math.max(0,Math.min(limit,this.track.scrollLeft+direction*width*count));this.track.scrollTo({left:target,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});}
update(){const width=this.cards[0].getBoundingClientRect().width+parseFloat(getComputedStyle(this.track).columnGap);const first=Math.round(this.track.scrollLeft/width)+1;const visible=matchMedia('(max-width:749px)').matches?1:3;this.previous.disabled=this.track.scrollLeft<2;this.next.disabled=this.track.scrollLeft>=this.track.scrollWidth-this.track.clientWidth-2;this.status.textContent=first+'–'+Math.min(this.cards.length,first+visible-1)+' / '+this.cards.length;}
disconnectedCallback(){this.resize?.disconnect();this.track?.removeEventListener('scroll',this.onScroll);this.previous?.removeEventListener('click',this.onPrevious);this.next?.removeEventListener('click',this.onNext);cancelAnimationFrame(this.frame);this.ready=false;}
});}


  } catch(e) { console.error(e); }
})();
})();
